<template>
  <SectionJobList
    title="Internal Job Referrals"
    type="filter" />
</template>

<script setup lang="ts">
  definePageMeta({
    layout: 'internal',
    middleware: ['internal-job-referrals']
  })

  useHead({
    meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }]
  })
</script>
